import { Box, Text } from '@chakra-ui/react';
import PageContainer from '../components/PageContainer';
import { t } from '../locales/locales';
import { ProjectItem } from '../components/ProjectItem';
import { ALL_PROJECTS } from '../constants/projects';

export default function Projects() {
  return (
    <PageContainer>
      <Box
        alignItems="center"
        justifyContent={'center'}
        display="flex"
        flexDirection="column"
      >
        <Text
          color="white"
          fontSize={'3xl'}
          textAlign={'center'}
          fontWeight={'medium'}
          mb={5}
          mt={8}
        >
          {t('projects')}
        </Text>
        <Text
          fontSize={'lg'}
          textAlign={'center'}
          fontWeight={'thin'}
          color="gray.400"
          mb={5}
          mt={2}
          maxWidth={{ base: 300, md: 300, lg: 600 }}
        >
          {t('projectsSummary')}
        </Text>
        <Text
          fontSize={'sm'}
          textAlign={'center'}
          color="gray.500"
          mt={1}
          maxWidth={{ base: 300, md: 300, lg: 600 }}
        >
          Additional enterprise and Government projects were worked on under
          strict{' '}
          <Text as="span" fontWeight="bold">
            NDA
          </Text>{' '}
          agreements or it's not released public yet and cannot be publicly
          disclosed.
        </Text>
      </Box>
      {ALL_PROJECTS.map((project) => (
        <ProjectItem key={project.id} project={project} />
      ))}
    </PageContainer>
  );
}
